export enum Scolarite {
  College = "college",
  EnseignementSuperieur = "enseignement_superieur",
  GrandeEcoleDuNumerique = "grande_ecole_du_numerique",
  Inconnue = "inconnue",
  Lycee = "lycee",
}

export enum ScolariteEnfant {
  Maternelle = "maternelle",
  Primaire = "primaire",
}

export enum Etudiant {
  Cap1 = "cap_1",
  Cap2 = "cap_2",
  Seconde = "seconde",
  Premiere = "premiere",
  Terminale = "terminale",
  Bts1 = "bts_1",
  But1 = "but_1",
  Cpge1 = "cpge_1",
  Licence1 = "licence_1",
  Licence2 = "licence_2",
  Licence3 = "licence_3",
  Master1 = "master_1",
  Master2 = "master_2",
  Doctorat1 = "doctorat_1",
  Doctorat2 = "doctorat_2",
  Doctorat3 = "doctorat_3",
  Autre = "autre",
}

export enum MentionBaccalaureat {
  MentionAssezBien = "mention_assez_bien",
  MentionBien = "mention_bien",
  MentionTresBien = "mention_tres_bien",
  MentionTresBienFelicitationsJury = "mention_tres_bien_felicitations_jury",
  NonRenseignee = "non_renseignee",
}

export enum GroupeSpecialite {
  Groupe330 = "groupe_330",
  Groupe230 = "groupe_230",
  Aucun = "aucun",
}
